import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { loadModelViewer } from "../utils/loadModelViewer";
import SeoHelmet from "../components/SeoHelmet";

import HeroStatementSection from "../components/HeroStatementSection";
import ServiceHero from "../components/ServiceHero";
import TechStackHero from "../components/TechStackHero";

import "@fontsource/poppins/400.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";
import "@fontsource/poppins/800.css";


function Hero({ serviceIsOpen, onServiceToggle, techIsOpen, onTechToggle, className = "" }) {
  const navigate = useNavigate();

  useEffect(() => {
    loadModelViewer();
  }, []);


  return (
    <>
      <SeoHelmet
        title="Denis Bitter – Software Architect & Full-Stack Engineering Instructor"
        description="React · Angular · Flutter · UI Engineering · System Architecture. Ich entwickle klare Systeme für Lernen, Web & App – durchdacht, echt, skalierbar. EdTech. Medien. Lösungen mit Haltung."
        url="https://www.denisbitter.de/"
        image="https://www.denisbitter.de/images/hero-og.jpg"
      />

      {/* ========== AKT 1: MEIN WARUM ========== */}
  <HeroStatementSection className={className} />

      {/* ========== 2. SOFTWARE DIE FUNKTIONIERT ========== */}
      <ServiceHero isOpen={serviceIsOpen} onToggle={onServiceToggle} />

         {/* ========== 3. TECH STACK + VERTRAUEN ========== */}
      
      
      {/* ========== 3. TECH STACK + VERTRAUEN ========== */}
      <TechStackHero
        isOpen={techIsOpen}
        onToggle={onTechToggle}
        onCompanyClick={() => {
          navigate("/about#referenzen");
          setTimeout(() => window.scrollTo({ top: 0, behavior: "instant" }), 0);
        }}
      />

   
    </>
  );

}

export default Hero;
